import React from 'react'
import Theme from "../../assets/ui/theme";
import {scrollToTheComponent} from "../../utils";
import {Flex, Text} from "../../assets/ui";
import {ArrowDownIcon} from "../../assets/icons";

const ScrollDown = () => {
    return (
        <Flex
            color={Theme.colors.silverWhite}
            fontSize="12px"
            cursor="pointer"
            // onClick={() => scrollToTheComponent("ExsportiaFeatures")}
            alignItems="flex-end"
        >
            <Text marginRight="18px">Scroll down to see more</Text>
            <ArrowDownIcon />
        </Flex>
    )
};

export default ScrollDown
